import React, { Component } from "react"
import { Button } from "antd"

import emptyStateActionPlans from "images/empty-state-action-plans.svg"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import { ACTION_PLANS } from "../../utils/constants"
import { isModuleBySlug } from "../../utils/storage"
import { loadTexts } from "../../utils/i18n"

class EmptyStateActionsPlans extends Component {
  intl = loadTexts("tracking")
  render() {
    const { setStateFrom } = this.props
    const isActionPlans = isModuleBySlug(ACTION_PLANS)
    if (!isActionPlans) {
      return null
    }
    return (
      <div className="container-actionplan__plans-empty">
        <img src={emptyStateActionPlans} alt="actions-plans" />
        <p>
          {this.intl.emptyStateActionPlans.title.first}
          <strong>{this.intl.emptyStateActionPlans.title.second}</strong>
          {this.intl.emptyStateActionPlans.title.third}
        </p>
        <div className="container-actionplan__plans-empty-border">
          {this.intl.emptyStateActionPlans.body}
        </div>
        <Button
          onClick={() => {
            woopraTrack("Crear plan de acción")
            setStateFrom({
              modalActionPlanCreate: true,
              modalActionPlanEditId: null,
            })
          }}>
          {this.intl.emptyStateActionPlans.button}
        </Button>
      </div>
    )
  }
}

export default EmptyStateActionsPlans
